import React from 'react';
import Main from "./Component/e-commerce/Main";
import ConfirmProduit from "./Component/e-commerce/ConfirmProduit";
import ConfirmCommande from "./Component/e-commerce/ConfirmCommande";
import Woman from "./Component/e-commerce/Woman";
import Sabot from "./Component/e-commerce/Sabot";
import Lunettes from "./Component/e-commerce/Lunettes";
import {BrowserRouter as Router , Switch,Route} from "react-router-dom";
import AddProductWomanSabot from "./Component/e-commerce/AddWomanSabot"
const App=()=> {
  return (
    <> 
        {/* <AddProductWomanSabot/> */}
      <Router>
        <Switch>
          <Route exact path="/" component={Main}></Route>
          <Route exact path="/Woman" component={Woman}></Route>
          <Route exact path="/Sabot" component={Sabot}></Route>
          <Route exact path="/Lunettes" component={Lunettes}></Route>
          <Route exact path="/Confirmation/:id" component={ConfirmProduit}></Route>
          <Route exact path="/Confirm_Commande" component={ConfirmCommande}></Route>
        </Switch>      
      </Router>
      </>
  );
}

export default App;
